export const Divider = () => {
	return (
		<div className="pattern-divider">
			<div className="w-full h-full bg-maroonSecondary bg-opacity-[0.15]"></div>
		</div>
	);
};
